import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ModalLayout } from '@appbase/templates'
import NavigationTab from '../NavigationTab.vue'
import { MenuInfo, getMenues } from './menu'
import { LanguageTime } from '@gnb/components/Preference/General/LanguageTime'
import { Notice } from '@gnb/components/Preference/General/Notice'
import { Missed } from '@gnb/components/Preference/Mail/Missed'
import { Layout } from '@gnb/components/Preference/Mail/Layout'
import { Signature } from '@gnb/components/Preference/Mail/Signature'
import { Rule } from '@gnb/components/Preference/Mail/Rule'
import { Delete } from '@gnb/components/Preference/Mail/Delete'
import { AutoDelivery } from '@gnb/components/Preference/Mail/AutoDelivery'
import { AutoReply } from '@gnb/components/Preference/Mail/AutoReply'
import { Category } from '@gnb/components/Preference/Mail/Category'
import { Storage } from '@gnb/components/Preference/Mail/Storage'
import { CalendarShared, Calendar } from '../../components/Preference/Calendar'
import { Setting, Confrontation, ChangeApprovalPW, Reception } from '../../components/Preference/Approval'
import  modalHelper  from '@appbase/util/modal-helper'
import AddRule from '@gnb/components/Preference/Mail/Rule/AddRule.vue'
import { mapGetters, mapActions } from 'vuex'
import * as accountTypes from '@account/store/types'
import * as types from '@gnb/store/types'



@Component({
    components: { 
        ModalLayout,
        NavigationTab, 
        'language':LanguageTime,
        'notice':Notice, 
        'missed': Missed, 
        'layout':Layout, 
        'signature':Signature,
        'rule':Rule,
        'delete':Delete,
        'autoDelivery':AutoDelivery,
        'autoReply':AutoReply,
        'category':Category,
        'storage':Storage,
        'calendarView':Calendar,
        'calendarShared':CalendarShared,
        'setting':Setting,
        'confrontationView':Confrontation,
        'changeApprovalPassword':ChangeApprovalPW,
        'addRule': AddRule,
        'reception' : Reception,
    },
    methods: {
      ...mapActions({
        loadAppOptions: types.APPOPTIONLIST_LOAD,
      }),
    },
    computed: {
        ...mapGetters({
          user: accountTypes.USER,
          current: accountTypes.CURRENT
        })
      }
})
export default class PreferneceModal extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    tmenues: MenuInfo[] = [];
    mchildren: MenuInfo[] = [];
    component: String = "language";
    user!: account.User;
    current!: account.TCurrent
    IsUsePassword: boolean = false; // 결재 비밀번호 옵션 사용여부
    
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadAppOptions!: (payload: gnb.RequestWorkflowOption) => Promise<gnb.CM_ApplicationOption>;

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('mchildren')
    changedMenues(){
        this.clickChildren(this.mchildren);
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    changed(items:MenuInfo[]){
        this.tmenues = items;
        this.getChildrenMenues();
    }

    getChildrenMenues(){
        var isFirst:boolean = false;

        this.tmenues.find((menu)=>{
            if(menu.selected && menu.children){
                this.mchildren = menu.children;
            }
        });
        this.mchildren.forEach((c)=>{
            if(c.selected){
                return;
            }else{
               isFirst = true;
            }
        })
        if(isFirst){
            this.mchildren[0].selected = true;
        }
    }

    clickChildren(items:MenuInfo[]){
        const { to }:any = items.find((i)=>{
            if(i.selected){
                return i;
            }
        });
        if (to) {
            this.component = to.name;
        }
    }

    open(componentName:string){
        this.component = componentName;
    }

    cancel(){
        this.tmenues.forEach((m)=>{
            if(m.name==='일반'){
                m.selected = true;
            }else{
                m.selected = false;
            }
            if(m.children){
                m.children.forEach((c)=>{
                    c.selected = false;
                })
            }
        });
        
        modalHelper.close();
        this.$router.go(0);
    }

    canUploadPersonPhoto(){
        this.tmenues.forEach((x:MenuInfo)=>{
            if(x.name == '사용자' && x.children != undefined){
                x.visible = !this.current.company.isHrPicture;
            }
        });
    }

    /**
     * 전자결재 시스템옵션 값을 조회합니다.
     */
    loadSystemOption(){
      this.loadAppOptions({ typeId: 2 } as gnb.RequestWorkflowOption)
        .then((res: gnb.CM_ApplicationOption) => {
          var systemOptions = res;
          var systemOption = {} as any
          systemOptions.optionList.forEach((x: gnb.CM_ApplicationOptionItem) => {
            if (x.optionItem.propertyName) {
              systemOption[x.optionItem.propertyName] =
                x.optionValues[0].subOptionValue !== null
                  ? x.optionValues[0].subOptionValue
                  : x.optionValues[0].subOptionCode
            }
          });
    
          this.IsUsePassword = systemOption['IsUsePassword'];
          this.setPasswordMenuVisibility();
        })
        .catch((err) => {
          console.error('loadSystemOption ERROR', err);
        });
        
    }


    
    setPasswordMenuVisibility(){
      this.tmenues.forEach((x: MenuInfo) => {
        if(x.name == '결재' && x.children != undefined){
          x.children[3].visible = this.IsUsePassword;
        }
      });

    }
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    mounted() {
        this.tmenues = getMenues(false);            
        this.tmenues[0].selected = true;
               
        this.loadSystemOption();
        this.canUploadPersonPhoto();
        this.getChildrenMenues();
    }
}